import type { FunctionComponent } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import {
  activeFiltersParam,
  pageParam,
  queryParam,
} from '../../../../pages/SearchPage/query-params'
import toSearchParams from '../../../utils/toSearchParams'
import type { AutoSuggestSearchResult } from './AutoSuggest'
import AutoSuggestItem from './AutoSuggestItem'
import { toDataSearch } from '../../../../links'

export interface AutoSuggestCategoryProps {
  category: AutoSuggestSearchResult
  highlightValue: string
  inputValue: string
  toggleMenu?: () => void
}

interface LocationDescriptorObject {
  pathname?: string | undefined
  search?: string | undefined
}

const AutoSuggestDropDownCategory = styled.div`
  padding: 1rem 0;
  border-bottom: 1px solid rgba(230, 230, 230, 1);
`
const AutoSuggestDropdownCategoryHeading = styled.p`
  font-size: 1.125rem;
  line-height: 1.6;
  margin: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
`

const AutoSuggestItemList = styled.div`
  width: 100%;
`

const AutoSuggestMoreResults = styled(Link)`
  font-size: 1.125rem;
  line-height: 1.6;
  color: #004699;
  text-decoration: none;

  &:hover,
  &.auto-suggest__dropdown-item--active {
    font-weight: inherit;
    color: #004699;
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`

const AutoSuggestCategory: FunctionComponent<AutoSuggestCategoryProps> = ({
  category,
  highlightValue,
  inputValue,
  toggleMenu,
}) => {
  const { type, label, content, totalResults } = category
  const moreResultsLink =
    totalResults > content.length ? getMoreResultsLink(inputValue, type) : null

  return (
    <AutoSuggestDropDownCategory>
      <AutoSuggestDropdownCategoryHeading data-testid="autoSuggestCategory">
        {label}
        {moreResultsLink && (
          <AutoSuggestMoreResults
            data-testid="autoSuggestMoreResultsLink"
            to={moreResultsLink}
            className="auto-suggest__dropdown-item--more-results"
            onClick={toggleMenu ? () => toggleMenu() : () => null}
          >
            Toon meer
          </AutoSuggestMoreResults>
        )}
      </AutoSuggestDropdownCategoryHeading>
      <AutoSuggestItemList>
        {content.map((suggestion) => (
          <AutoSuggestItem
            key={`${suggestion.label}${suggestion?.id ?? ''}`}
            suggestion={suggestion}
            content={suggestion.label}
            highlightValue={highlightValue}
            label={label}
            toggleMenu={toggleMenu}
          />
        ))}
      </AutoSuggestItemList>
    </AutoSuggestDropDownCategory>
  )
}

function getMoreResultsLink(inputValue: string, subType?: string): LocationDescriptorObject | null {
  return {
    ...toDataSearch(),
    search: toSearchParams([
      [queryParam, inputValue],
      [pageParam, pageParam.defaultValue],
      [activeFiltersParam, subType ? [{ type: 'dataTypes', values: [subType] }] : []],
    ]).toString(),
  }
}

export default AutoSuggestCategory
